"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResurrectPetAbilityHandler = exports.ResurrectPetActorAbilityFactory = exports.ResurrectPetAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class ResurrectPetAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ResurrectPet;
        this.__typeName = "ResurrectPet";
    }
}
exports.ResurrectPetAbilityArgs = ResurrectPetAbilityArgs;
let ResurrectPetActorAbilityFactory = class ResurrectPetActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ResurrectPet", "OneCompanion", 3);
    }
};
ResurrectPetActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ResurrectPet")
], ResurrectPetActorAbilityFactory);
exports.ResurrectPetActorAbilityFactory = ResurrectPetActorAbilityFactory;
let ResurrectPetAbilityHandler = class ResurrectPetAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [companionId] = ability.args.target.actorIds;
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                sequence
                    .push(core_1.AnimateCharacterVfxStepArgs.Resurrected(companionId))
                    .push(new core_1.CharacterSoundEffectVfxStepArgs(companionId, "resurrected"))
                    .push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(companionId, "feet"), "BlueLightPillar"));
                container.applyBuff({
                    creatorId: ability.invokerId,
                    targetId: companionId,
                    effect: new __1.ResurrectEffectArgs("ResurrectPet"),
                    duration: Duration_1.Duration.Instant,
                    sequence: sequence.pushSequence("sequential"),
                });
            }
        });
    }
};
ResurrectPetAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ResurrectPet)
], ResurrectPetAbilityHandler);
exports.ResurrectPetAbilityHandler = ResurrectPetAbilityHandler;
